"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.valueToResponse = function (value) {
  return new Promise(function (resolve) {
    return resolve({
      ok: true,
      json: function json() {
        return new Promise(function (r) {
          return r(value);
        });
      }
    });
  });
};